module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('el-card', [_c('el-alert', {
    attrs: {
      "title": "活动价格",
      "type": "info",
      "description": "",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "160px"
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入活动名称"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动开始时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择开始时间",
      "value-format": "yyyy-MM-dd "
    },
    model: {
      value: (_vm.form.start_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "start_time", $$v)
      },
      expression: "form.start_time"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动结束时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择结束时间",
      "value-format": "yyyy-MM-dd "
    },
    model: {
      value: (_vm.form.end_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "end_time", $$v)
      },
      expression: "form.end_time"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动描述"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "活动时间"
    },
    model: {
      value: (_vm.form.msg),
      callback: function($$v) {
        _vm.$set(_vm.form, "msg", $$v)
      },
      expression: "form.msg"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer content-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(" 确定 ")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f2832b0a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f2832b0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/goods/priceviewtitle.vue
// module id = 2980
// module chunks = 0